import { Box, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { WrapperCardWithTitle } from '../../../layouts/WrapperCardWithTitle';

interface ExtraFieldsCardProps {
  extraFields: Record<string, unknown>;
}

export function ExtraFieldsCard({ extraFields }: ExtraFieldsCardProps): ReactElement {
  const { t } = useTranslation();

  return (
    <WrapperCardWithTitle
      title='heap.extraFields.title'
      elevation={0}
      sx={{ height: 'auto', flexShrink: 0 }}
      contentSx={{ flex: 'none', maxHeight: '150px', padding: 1 }}
    >
      <Box display='flex' flexDirection='column' gap={0.5} padding={1} border='1px solid #e0e0e0' borderRadius={1}>
        {Object.entries(extraFields).map(([key, value]) => (
          <Typography key={key}>
            {t(`heap.extraFields.${key}`, {
              value,
              defaultValue: `${key}: ${String(value)}`,
            })}
          </Typography>
        ))}
      </Box>
    </WrapperCardWithTitle>
  );
}
